<template>
    <div class="portfolio-internship">
        <span
            class="portfolio-internship__sticker"
            :class="{
                [`portfolio-internship__sticker--${stickerName}`]: true,
            }"
        >
            {{ statusName }}
        </span>
        <div class="portfolio-internship__image">
            <img v-if="item.logo" :src="item.logo" alt="" />
            <img v-else src="~@/assets/images/portfolio/no-image.svg" alt="" />
        </div>
        <div v-if="item.name" class="portfolio-internship__name">
            {{ truncatedText }}
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: {
        item: Object,
    },
    data: () => ({
        competencesOpened: false,
    }),
    computed: {
        ...mapGetters('data', [
            'getRegistryItems',
        ]),
        ...mapGetters('competences', [
            'getSoftCompetences',
            'getHardCompetences',
        ]),

        participantStatus() {
            return this.item.nominations[0].participantStatus;
        },

        stageHistoryItem() {
            const status = this.participantStatus;
            return this.getRegistryItems('stage_history').find(v => v.id === status);
        },

        stickerName() {
            const item = this.stageHistoryItem;
            return item ? item.field_name : 'default';
        },

        statusName() {
            const item = this.stageHistoryItem;
            return item ? item.field_value : '';
        },

        truncatedText() {
            return this.truncate(this.item.name, 34, "...");
        },
    },

    methods: {
        truncate (text, length, suffix = "...") {
            if (text.length > length) {
            return text.substring(0, length) + suffix;
            } else {
            return text;
            }
        },
    },
};

</script>

<style scoped lang="scss">
@import "~@/styles/rem";
@import '~@/styles/variables';

.portfolio-internship {
    position: relative;
    display: flex;
    flex-direction: column;
    border-radius: mrem(16);
    min-height: mrem(237);
    height: mrem(237);
    max-width: mrem(171);
    background: #F6FAFD;

    @include on-desktop {
        border-radius: rem(16);
        min-height: rem(237);
        height: rem(237);
        max-width: rem(171);
    }

    &__sticker {
        $stickerColorDefault: #E1F4E4;

        position: absolute;
        top: mrem(18);
        left: 0;
        padding: mrem(2) mrem(16);
        color: #251F45;
        font-family: "Montserrat", sans-serif;
        font-size: mrem(12);
        font-weight: 600;
        line-height: mrem(22);
        border-top-right-radius: mrem(16);
        border-bottom-right-radius: mrem(16);
        background: $stickerColorDefault;

        @include on-desktop {
            top: rem(18);
            left: 0;
            font-size: rem(12);
            font-weight: 600;
            line-height: rem(22);
            padding: rem(2) rem(16);
            border-top-right-radius: rem(16);
            border-bottom-right-radius: rem(16);
        }

        $stickerColors: (
            default: $stickerColorDefault,
            expert: #D4EAFE,
            candidate: #D4EAFE,
            final: #E1DFEC,
            hero: #D4EAFE,
            star: #D4EAFE,
            party: #E1F4E4,
            volont: #D4EAFE,
            knewer: #D4EAFE,
            profi: #D4EAFE,
            new: #D4EAFE,
            super: #D4EAFE,
            sledopyt: #D4EAFE,
            winner: #D4EAFE,
            mentor: #D4EAFE,
            student: #D4EAFE,
            graduate: #D4EAFE,
            prise: #D4EAFE,
            teacher: #D4EAFE,
            half: #A0C8EA,
            main: #D4EAFE,
        );
        @each $stickerName, $stickerColor in $stickerColors {
            &--#{$stickerName} {
                background-color: $stickerColor;
            }
        }
    }

    &__image {
        margin-top: mrem(34);
        border-radius: mrem(10);
        width: 100%;
        @include on-desktop {
            margin-top: rem(34);
            border-radius: rem(10);
            width: 100%;
        }

        img {
            border-radius: mrem(10);
            width: 100%;
            @include on-desktop {
                border-radius: rem(10);
            }
        }
    }

    &__name {
        color: #251F45;
        font-weight: 700;
        font-size: mrem(14);
        line-height: mrem(24);
        margin-top: mrem(16);
        @include on-desktop {
            margin-top: rem(16);
            font-size: rem(14);
            line-height: rem(24);
        }
    }
}

</style>
